export function initSearch() {
  var searchIcon = document.getElementById('search-icon');
  var searchModal = document.getElementById('search-modal');
  var closeModal = searchModal.querySelector('.search__close');
  
  var searchForm = document.querySelector('.search-form');
  var searchInput = searchForm.querySelector('.search-field');
  var resultsContainer = document.querySelector('.search-results');

/* Search Modal */

searchIcon.addEventListener('click', function () {
  openSearchModal();
});

closeModal.addEventListener('click', function () {
  closeSearchModal();
});

window.addEventListener('click', function (event) {
  if (event.target === searchModal) {
    closeSearchModal();
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeSearchModal();
  }
});

function openSearchModal() {
  searchModal.style.display = 'block';
  document.body.classList.add('modal-open');
}

function closeSearchModal() {
  searchModal.style.display = 'none';
  document.body.classList.remove('modal-open');
}

/* Search AJAX */
  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    performSearch();
  });

  function performSearch() {
    var searchQuery = searchInput.value;

    if (searchQuery.length < 2) {
      resultsContainer.innerHTML = '<p>Bitte geben Sie mindestens 2 Zeichen ein.</p>';
      return;
    }

    resultsContainer.innerHTML = '<p>Wird geladen...</p>';

    var xhr = new XMLHttpRequest();
    xhr.open('GET', searchForm.action + '?s=' + encodeURIComponent(searchQuery) + '&ajax=1');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          var html = '';

          if (response.length > 0) {
            html += '<ul>';
            for (var i = 0; i < response.length; i++) {
              html += '<li><a href="' + response[i].link + '">' + response[i].title + '</a></li>';
            }
            html += '</ul>';
          } else {
            html = '<p>Keine Ergebnisse gefunden.</p>';
          }

          resultsContainer.innerHTML = html;
        } else {
          resultsContainer.innerHTML = '<p>Ein Fehler ist aufgetreten.</p>';
        }
      }
    };
    xhr.send();
  }
}
